import { css } from 'styled-components';
import { colors } from '../../config/styles';
import { IStyledFieldDesignProps } from './types';
import { theme } from '../../styles/theme';
import { formInputStyles } from '../../styles/shareableStyles';

/**
 * There are 2 styles of fields: text inputs and highlighted(value) inputs.
 * In general, text inputs are grey and highlighted inputs are blue;
 */

export const defaultInputStyles = css<IStyledFieldDesignProps>`
  display: block;
  width: 100%;
  min-height: 28px;
  padding: 4px 8px;
  font: inherit;
  letter-spacing: normal;
  outline: none;
  ${formInputStyles};
  &::placeholder {
    font-size: inherit;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 18px;
    color: ${theme.colors.secondary400};
  }
  &:not(:disabled):focus,
  &:not(:disabled):hover {
    border-color: ${theme.colors.mainBlue};
  }
  &:disabled {
    cursor: not-allowed;
  }
  &:disabled {
    color: ${theme.colors.secondary400};
    background-color: ${theme.colors.level1};
  }
  ${({ $hasError }) =>
    $hasError &&
    css`
      &:not(:focus) {
        border-color: ${colors.mainError};
      }
    `}
`;

export const fieldErrorStyles = css`
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: ${colors.mainError};
`;
